import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { motion } from 'framer-motion';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hoverEffect?: boolean;
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  className,
  hoverEffect = false,
  ...props
}, ref) => {
  return <motion.div initial={hoverEffect ? {
    y: 0
  } : undefined} whileHover={hoverEffect ? {
    y: -5
  } : undefined} ref={ref as any} className={cn('rounded-xl border border-slate-200 bg-white text-slate-950 shadow-sm', className)} {...props as any} data-id="element-264" />;
});
Card.displayName = 'Card';